/* eslint-disable jam3/no-sanitizer-with-danger */

import LoadingIndicator from '@gameday/react-components/components/LoadingIndicator'
import OrganisationHeader from '@gameday/react-components/components/OrganisationHeader'
import theme from '@gameday/react-components/utils/theme'
import styled from 'styled-components'

import styles from '../WizardPage/styles.scss'

const StyledHomePageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const StyledMain = styled.main`
  height: 100%;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  > div {
    flex-grow: 1;
  }
`

const HomePageComponent = ({
  children,
  isAuthenticated,
  formId,
  formTitle,
  formName,
  orgLogo,
  landingPageLogo,
  organisationName,
  organisationId,
  userName,
  logOutRequest,
  showLoadingIndicator,
  eventLogo,
  formType,
  loadingIndicatorContent,
  landingPageLink = '',
  teamsByUser = [],
  teamsInEvent = [],
  appVersion,
}) => {
  const hideCaptcha = '.grecaptcha-badge { visibility: hidden; }'
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const usersTeamIds = (teamsByUser[0] && teamsByUser[0].value.map(t => t.id)) || []
  const userRegisteredATeam = !!teamsInEvent.find(t => usersTeamIds.includes(t.teamId))

  return (
    <StyledHomePageContainer>
      {GlobalStyles}
      {organisationId && formId && (
        <OrganisationHeader
          isAuthenticated={isAuthenticated}
          formTitle={formType === 'event' ? formName : formTitle}
          formLogo={formType !== 'event' ? landingPageLogo : orgLogo}
          orgName={organisationName}
          orgLogo={formType !== 'event' ? orgLogo : eventLogo}
          landingPageLink={formType === 'event' ? landingPageLink : ''}
          portalLink={userRegisteredATeam ? landingPageLink.concat('/portal') : ''}
          userName={userName}
          logOutRequest={logOutRequest}
          appVersion={appVersion}
        />
      )}
      {/*
        There was an entire compnent that turned these on and off.
        To fix PLAT-5225, the component was removed.
      */}
      <StyledMain>{children}</StyledMain>
      {showLoadingIndicator && (
        <div className={styles.loadingIconContainer}>
          <LoadingIndicator />
          {loadingIndicatorContent}
        </div>
      )}
      {isAuthenticated && <style>{hideCaptcha}</style>}
    </StyledHomePageContainer>
  )
}

HomePageComponent.defaultProps = {
  children: null,
  formId: null,
  formTitle: null,
  headerColour: theme.header.background,
  headerLogo: null,
  headerTextColour: theme.header.textColor,
  landingPageLogo: null,
  organisationId: null,
  systemAlert: {},
}

const GlobalStyles = (
  <style
    // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
    dangerouslySetInnerHTML={{
      __html: `
      .header-wrapper .headroom {
        position: absolute !important;
      }

      .headroom--pinned,
      .headroom--unfixed {
        z-index: 2 !important;
      }

      .headroom--unpinned {
        z-index: 0 !important;
      }
    `,
    }}
  />
)

export default HomePageComponent
